export const interviewReports = {
  id: 'interviews',
  name: 'Interviews',
  description: '',
  visibility: 'private',
  subject_type: 'interviews',
  layout: {
    data: [
      {
        h: 7,
        w: 4,
        x: 0,
        y: 0,
        key: '4822',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 4,
        x: 4,
        y: 0,
        key: '4823',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 4,
        x: 8,
        y: 0,
        key: '4824',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 23,
        w: 12,
        x: 0,
        y: 7,
        key: '4825',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 23,
        w: 6,
        x: 0,
        y: 30,
        key: '4826',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 23,
        w: 6,
        x: 6,
        y: 30,
        key: '4827',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 18,
        w: 12,
        x: 0,
        y: 53,
        key: '4828',
        maxH: 100,
        maxW: 12,
        minH: 8,
        minW: 8,
      },
    ],
  },
  tiles: [
    {
      id: 4822,
      subject_type: 'interviews',
      metadata: {
        id: 'interviews_completed',
        tileKey: 'interviews_completed',
        apiParam: 'card',
        headerKey: 'interviews_completed',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4823,
      subject_type: 'interviews',
      metadata: {
        id: 'applicants_interviewed',
        tileKey: 'applicants_interviewed',
        apiParam: 'card',
        headerKey: 'applicants_interviewed',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4824,
      subject_type: 'interviews',
      metadata: {
        id: 'time_spent_interviewing',
        unit: 'time',
        tileKey: 'time_spent_interviewing',
        apiParam: 'card',
        metricKeys: {
          numerator: 'total_interview_duration',
          denominator: 'interviews_completed',
        },
        componentType: 'card',
        calculationType: 'avgChange',
      },
      query: null,
    },
    {
      id: 4825,
      subject_type: 'interviews',
      metadata: {
        id: 'interviews_trend_chart',
        tileKey: 'interviews_trend_chart',
        apiParam: 'chart_table',
        headerKeys: [],
        componentType: 'chart',
      },
      query: null,
    },
    {
      id: 4826,
      subject_type: 'interviews',
      metadata: {
        id: 'interviews_feedback_chart',
        tileKey: 'interviews_feedback_chart',
        apiParam: 'visual',
        headerKeys: [],
        componentType: 'chart',
        defaultFilters: {
          group_by_1: 'duration',
        },
      },
      query: null,
    },
    {
      id: 4827,
      subject_type: 'interviews',
      metadata: {
        id: 'interviews_duration_chart',
        tileKey: 'interviews_duration_chart',
        apiParam: 'visual',
        headerKeys: [],
        componentType: 'chart',
        defaultFilters: {
          group_by_1: 'duration',
        },
      },
      query: null,
    },
    {
      id: 4828,
      subject_type: 'interviews',
      metadata: {
        id: 'interviews_table',
        tileKey: 'interviews_table',
        apiParam: 'chart_table',
        headerKeys: [
          'interviews_completed',
          'scorecards_filled',
          'time_to_fill_scorecard',
          'total_interview_duration',
          'applicants_interviewed',
          'strong_yes',
          'yes',
          'strong_no',
          'no',
        ],
        componentType: 'table',
      },
      query: null,
    },
  ],
  user: {
    id: null,
  },
};
